import { createSelector } from '@reduxjs/toolkit';
import { NavigationSliceState } from '@va/dashboard/types/store';
import { Map } from 'immutable';

const baseSelector = (state: Map<any, any>) => state.getIn(['core', 'ui', 'navigation'], {}) as NavigationSliceState;

export const isSidebarOpen = createSelector(baseSelector, (data) => data.isSidebarOpen);
